module.exports = __webpack_public_path__ + "static/img/img_logo.07419ac5.png";